<template>
  <div>
    <sidebar-menu :menu="menu" title="METERS" />

    <div class="container-fluid my-3">
      <div class="row">
        <div class="col-8 col-sm-5 col-lg-5 my-auto">
          <h5 class="modal-title" id="addMeterReadingLabel">
            Add Meter Reading
          </h5>
        </div>
        <div class="col">
          <div class="float-right mt-2">
            <span>
              <a class="close">
                <i
                  class="far fa-times-circle fa-2x"
                  aria-label="Close"
                  @click="closePanel"
                ></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          id="panel-content-container"
          class="container-fluid slide_out_container no-pad mt-4"
        >
          <gas-reading v-if="activeMeter.ServiceType === 'Gas'" />
          <electricity-reading-set
            v-if="activeMeter.ServiceType === 'Electricity'"
            :meter="activeMeter"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SidebarMenu from "vue-sidebar-menu";
import SidebarMenu from '../sidebar-components/ReadingsSidebar.vue';
import GasReading from './GasReading.vue';
import ElectricityReadingSet from './ElectricityReadingSet.vue';

export default {
	components: {
		SidebarMenu,
		GasReading,
		ElectricityReadingSet,
	},
	created() {
		if (
			this.menu &&
			this.menu.length > 0
		) {
			this.$store.dispatch('changeActiveMeter', this.menu[0].meter);
		}
	},
	methods: {
		closePanel() {
			this.$emit('closePanel');
		},
		// onMenuItemClick(event, item) {
		//   this.$store.dispatch("changeActiveMeter", item.meter);
		// },
	},
	computed: {
		// activeService() {
		//   return this.$store.state.meters.activeService
		// },
		activeMeter() {
			return this.$store.state.meters.activeMeter;
		},
    services() {
      let services = this.$store.state.contracts.services
        ? [...this.$store.state.contracts.services]
        : [];
      services = services.sort((serviceA, serviceB) => {
        if (serviceA.Contract.StartDate < serviceB.Contract.StartDate) return 1;
        else if (serviceA.Contract.StartDate > serviceB.Contract.StartDate)
          return -1;
        else if (serviceA.Contract.Created > serviceB.Contract.Created)
          return -1;
        else return 1;
      });
      return this.$_.uniq(
        services,
        true,
        this.$_.iteratee((service) => service.Service.ServiceIdentifier)
      );
    },
		menu() {
			return this.$store.getters.readingsPanelMenu(
				this.services
			);
		},
	},
};
</script>
